export default {
  main: {
    site_id: 18747994,
    title: "Terminal PRO",
    logoSize: "big",
    hotjarId: 4937905,
    staffPassword: "0",
    websitePasswordHash: "20fcb6fe7e688028541c0a51b2f29edc41df2a659c3409a680a55556e392e95a",
    homeBannerSlides: [
      {
        fileType: 'jpeg',
        path: "/betting/prematch",
      },
    ],
    homeMediaSlides: [
      {
        type: "casino",
        path: "casino",
      },
      {
        type: "sport",
        path: "betting/prematch",
      },
    ],
    availableLanguages: {
      "@replace": true,
      hrv: {
        short: "hr",
        name: "HRV",
        region: "Montenegro",
        order: 1,
      },
      eng: {
        short: "EN",
        name: "ENG",
        region: "United Kingdom",
        order: 2,
      },
    },
  },
  env: {
    lang: "hrv",
  },
  casino: {
    enabledProvidersList: ["PPG", "PCG"],
    gameOpenFullscreen: "automatic",
  },
  routes: [
    {
      name: 'Betting',
      url: 'betting/prematch/all',
      type: 'sportsBook',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/live/all',
          type: 'live',
          name: 'Live',
          enabled: true,
          icon: 'circle',
        },
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'Sports',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/results',
          name: 'Results',
          type: 'results',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      name: 'Casino',
      url: 'casino',
      type: 'casino',
      enabled: true,
    },
    {
      url: 'tickets',
      name: 'Tickets',
      enabled: true,
    },
  ],
  defaultTerminalParams: { pid: 18747994, tid: 24555, token: "Ucg1Fg==", currency: "EUR" },
};
